import { PunchAction, PunchActionTypes } from '@completion/actions';
import { Attachment, Punch, punchItemSort } from '@completion/models';

export const initialState: PunchState = {
  punches: [],
  userPunches: [],
  unacceptedPunches: [],
  prePunches: [],
  punch: null,
  deleteStatus: null,
  attachments: null,
  selectedAttachment: null,
};

export interface PunchState {
  punches: Punch[];
  userPunches: Punch[];
  unacceptedPunches: Punch[];
  prePunches: Punch[];
  punch: Punch;
  deleteStatus: number;
  selectedAttachment: Blob;
  attachments: Attachment[];
}

export function punchReducer(state: PunchState = initialState, action: PunchAction): PunchState {
  switch (action.type) {
    case PunchActionTypes.LoadPunchesSuccess:
      return {
        ...state,
        punches: [...action.punches].sort(punchItemSort),
      };
    case PunchActionTypes.CreatePunchSuccess:
      return {
        ...state,
        punch: action.punch,
      };
    case PunchActionTypes.UpdatePunchSuccess: {
      const updated = action.punch;
      return {
        ...state,
        punch: updated,
        punches: updatePunchInCollection(state.punches, updated),
        userPunches: updatePunchInCollection(state.userPunches, updated),
        unacceptedPunches: updatePunchInCollection(state.unacceptedPunches, updated),
      };
    }
    case PunchActionTypes.LoadPunchByIdSuccess: {
      const updated = action.punch;
      return {
        ...state,
        punch: updated,
        punches: updatePunchInCollection(state.punches, updated),
        userPunches: updatePunchInCollection(state.userPunches, updated),
        unacceptedPunches: updatePunchInCollection(state.unacceptedPunches, updated),
      };
    }
    case PunchActionTypes.ClearPunch:
      return {
        ...state,
        punch: null,
        deleteStatus: null,
        selectedAttachment: null,
        attachments: null,
      };
    case PunchActionTypes.DeletePunchSuccess:
      return {
        ...state,
        deleteStatus: action.deleteStatus,
      };
    case PunchActionTypes.LoadSelectedAttachmentSuccess:
      return {
        ...state,
        selectedAttachment: action.attachment,
      };
    case PunchActionTypes.ClearSelectedAttachment:
      return {
        ...state,
        selectedAttachment: null,
      };
    case PunchActionTypes.UploadAttachmentsSuccess:
      return {
        ...state,
        attachments: action.attachments,
      };
    // DeleteAttachmentSuccess removed; attachment deletions are handled when the punch is saved
    case PunchActionTypes.LoadUserPunchesSuccess:
      return {
        ...state,
        userPunches: [...action.punches].sort(punchItemSort),
      };
    case PunchActionTypes.LoadUnacceptedPunchesSuccess:
      return {
        ...state,
        unacceptedPunches: [...action.punches],
      };
    case PunchActionTypes.LoadPrePunchesSuccess:
      return {
        ...state,
        prePunches: [...action.punches],
      };
    case PunchActionTypes.RemoveAcceptedFromUnaccepted:
      return {
        ...state,
        unacceptedPunches: (state.unacceptedPunches || []).filter((p) => !action.punchIds.includes(p.id)),
      };
    case PunchActionTypes.ClearPunches:
      return {
        ...state,
        punches: [],
        userPunches: [],
        unacceptedPunches: [],
        prePunches: [],
        punch: null,
        deleteStatus: null,
        selectedAttachment: null,
        attachments: null,
      };
    default:
      return state;
  }
}

export function getUpdatedPunch(punchId: number, attachmentId: number, punches: Punch[]) {
  const punch = punches.find((p) => p.id === punchId);
  const index = punch.attachments.indexOf(punch.attachments.find((a) => a.id === attachmentId));
  return {
    ...punches.find((p) => p.id === punchId),
    attachments: [...punch.attachments.slice(0, index), ...punch.attachments.slice(index + 1)],
  };
}

function updatePunchInCollection(collection: Punch[], updated: Punch): Punch[] {
  if (!collection || collection.length === 0) {
    return collection;
  }
  if (!collection.some((p) => p.id === updated.id)) {
    return collection;
  }
  // Replace the punch with the updated one; keep existing order
  return collection.map((p) => (p.id === updated.id ? { ...updated } : p));
}
